/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 *
 *
 * NOTE: Hand-added (not regenerated from /api-docs - backend endpoint lives in a parallel
 * session with no live /api-docs yet). Remove this note once a real swagger regen covers it.
 */

export interface TagSuggestionResponse {
    tagId?: string;
    tagName?: string;
    source?: TagSuggestionResponse.SourceEnum;
    confidence?: number;
    color?: number;
    similarTenderId?: string;
    similarTenderTitle?: string;
    similarity?: number;
    modelVersion?: string;
    createdAt?: string;
}
export namespace TagSuggestionResponse {
    export type SourceEnum = 'COPY' | 'AI' | 'EMPLOYEE';
    export const SourceEnum = {
        COPY: 'COPY' as SourceEnum,
        AI: 'AI' as SourceEnum,
        EMPLOYEE: 'EMPLOYEE' as SourceEnum
    };
}
